<div class="container-fluid header-img">
    <div class="logo py-2">
        <img src="assets/images/logo_latest.png" alt="logo"/>
    </div>
</div>
